/* eslint-disable */
import { createRouter, createWebHistory } from 'vue-router'
// 路由懒加载
const EditorPage = () => import('../pages/Editor.vue')
const EditorVuePage = () => import('../pages/EditorVue.vue')
const EditorReactPage = () => import('../pages/EditorReact.vue')
const HomePage = () => import('../pages/Home.vue')
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'Home',
      component: HomePage,
    },
    {
      path: '/js-lib',
      name: 'editor',
      component: EditorPage,
    },
    {
      path: '/vue-component',
      name: 'editor-vue',
      component: EditorVuePage,
    },
    {
      path: '/react-component',
      name: 'editor-react',
      component: EditorReactPage,
    },
  ],
})

export default router
